import {
  ListItemText as MuiListItemText,
  ListItemTextProps as MuiListItemTextProps,
} from '@mui/material';

export type ListItemTextProps = MuiListItemTextProps;

export const ListItemText = MuiListItemText;
